import React, {FC, Fragment} from 'react';
import {connect} from 'react-redux';
import {range, splitEvery} from 'ramda';

import {ApplicationStoreType} from 'constants/flow/flowTypes';
import {isContactLensesPage} from 'selectors/router/router';
import {LensesPlaceholder} from 'features/categoryRefinements/components/category/lensesPlaceholder/lensesPlaceholder';

export type PropsType = {
    isContactLenses: boolean;
};

import s from './categorySkeleton.scss';
import {TopSectionContactsPlaceholder} from './topSectionContactsPlaceholder/topSectionContactsPlaceholder';
import {TopSectionPlaceholder} from './topSectionPlaceholder/topSectionPlaceholder';

/**
 * Single line product list
 * @param {PropsType} props - component properties
 * @return {React.ReactElement} rendered component
 */
export const CategorySkeleton: FC<PropsType> = ({isContactLenses}) => {
    if (isContactLenses) {
        return (
            <>
                <TopSectionContactsPlaceholder />
                <ul>
                    {splitEvery(1, range(1, 28)).map((chunkItem: number[]) => (
                        <li className={s.item} key={chunkItem.join()}>
                            {chunkItem.map((number: number) => (
                                <Fragment key={number}>
                                    <LensesPlaceholder />
                                </Fragment>
                            ))}
                        </li>
                    ))}
                </ul>
            </>
        );
    }
    return (
        <>
            <TopSectionPlaceholder />
            <div className={s.productsContainer}>
                <ul className={s.list}>
                    {splitEvery(1, range(1, 28)).map((chunkItem: number[]) => (
                        <li className={s.product} key={chunkItem.join()} />
                    ))}
                </ul>
            </div>
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    isContactLenses: isContactLensesPage(store),
});

export const CategorySkeletonConnected = connect(mapStateToProps)(CategorySkeleton);
